import { WatchStopHandle, watch, Ref } from 'vue';
import { BodyFormModel } from '@/presentation/components/form/BodyFormModel';
import { mediatedEventPublish } from '@/platform/core/MediatedEvents';
import { EditorEvent } from '@studyportals/bodies-editor-integration';

export class EditorDirtyStateMonitor {
	private readonly formModel: Ref<BodyFormModel | undefined>;

	private watchStopHandle: WatchStopHandle | undefined;

	public constructor(formModel: Ref<BodyFormModel | undefined>) {
		this.formModel = formModel;
	}

	public start(): void {
		this.watchStopHandle = watch(
			[
				(): Ref => this.formModel.value!.name,
				(): Ref => this.formModel.value!.type,
			],
			async (): Promise<void> => {
				this.notifyDirty();
			},
		);
	}

	public stop(): void {
		if (this.watchStopHandle) {
			this.watchStopHandle();
			this.watchStopHandle = undefined;
		}
	}

	private notifyDirty(): void {
		mediatedEventPublish(EditorEvent.FORM_DIRTY, true);
	}
}
